import { autoAnimatePlugin } from '@formkit/auto-animate/vue'

export default defineNuxtPlugin(nuxtApp => {
  const { vueApp } = nuxtApp;
  vueApp.use(autoAnimatePlugin);
});
